export default "__VITE_ASSET__d9041464__"